module.exports = __webpack_public_path__ + "img/2.8d0349b1.png";